function OnLoadHelper() {
  this.loaded = false;
  this.queue = [];

  this.onLoadShim = () => {
    this.onLoad();
  };

  const loadedStates = ['complete', 'loaded', 'interactive'];

  if (loadedStates.indexOf(document.readyState) !== -1) {
    this.onLoad();
    return;
  }

  document.addEventListener('DOMContentLoaded', this.onLoadShim);
}

OnLoadHelper.prototype = {
  run(fn) {
    if (typeof fn !== 'function') return;

    if (this.loaded) {
      fn();
      return;
    }

    this.queue.push(fn);
  },

  onLoad() {
    if (this.loaded) return;
    this.loaded = true;
    this.queue.forEach((fn) => fn());
    this.queue.splice(0, this.queue.length);
  },
};

export default new OnLoadHelper();
